/**
 *
 * Asynchronously loads the component for SessionCompletedPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
